


(function () {
  function updateStock(sectionId, variantId) {
    var variants = window["productVariants_" + sectionId];
    var target = document.getElementById("stock-status-" + sectionId);
    if (!variants || !target) return;

    var v = variants.find(x => String(x.id) === String(variantId));
    if (!v) return;

    var qty = Number(v.inventory_quantity || 0);
    var cls = "stock";
    var html = "";

    if (v.inventory_management) {

      if (qty > 0) {
        if (qty < 15) {
          cls += " stock--critical";   // red
        } else if (qty < 50) {
          cls += " stock--low";        // amber
        } else {
          cls += " stock--in";         // green
        }
        html = "In Stock — " + qty + "pcs";

      } else {
        if (v.inventory_policy === "continue") {
          cls += " stock--backorder";
          html = "Available on backorder";
        } else {
          cls += " stock--out";
          html = "Out of stock";
        }
      }

    }

    target.innerHTML = '<p class="' + cls + '">' + html + "</p>";
  }

  document.addEventListener("change", function (e) {
    if (e.target && e.target.name === "id") {
      var box = document.querySelector('[id^="stock-status-"]');
      if (!box) return;
      var sectionId = box.id.replace("stock-status-", "");
      updateStock(sectionId, e.target.value);
    }
  });
})();


